import { SectionType } from 'types/enums';

export const getNextSectionId = (
  sections: TimelineSectionBase[],
  currentSection: TimelineSectionBase
): string | null => {
  let foundCurrent = false;
  let fallbackFirst: string | null = null;

  return (
    sections.reduce<string | null>((result, section) => {
      if (section.type !== SectionType.headline && !fallbackFirst) {
        fallbackFirst = section._id;
      }

      if (result) return result;

      if (!foundCurrent) {
        if (section._id === currentSection._id) {
          foundCurrent = true;
        }
        return null;
      }

      if (section.type !== 'headline') {
        return section._id;
      }

      return null;
    }, null) || fallbackFirst
  );
};
